<template>
	<v-menu
		v-model="menu"
		:open-on-focus="false"
		location="center center"
		submenu
		:close-on-content-click="false"
	>
		<template #activator="{ props }">
			<v-list-item
				v-bind="props"
				:title="`${t('component.contentAlign.name')}: ${t(`component.contentAlign.${contentAlign}`)}`"
				:prepend-icon="t('component.contentAlign.icon')"
				data-test="profile-menu__content-align-list-item"
				append-icon="fas fa-chevron-right"
			></v-list-item>
		</template>
		<v-list
			:title="t('component.contentAlign.name')"
			:selected="[contentAlign]"
			:items="values"
			color="primary"
			@update:selected="change"
		>
		</v-list>
	</v-menu>
</template>
<script setup lang="ts">
import {
	contentAlignValues,
	useContentAlign,
	type ContentAlign,
} from '@/composables/useContentAlign'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const menu = ref(false)
const { t } = useI18n()
const { contentAlign } = useContentAlign()

const values = computed(() => [
	{
		title: t('component.contentAlign.name'),
		type: 'header',
		props: {
			twoLine: true,
			appendIcon: '$close',
			onClick: () => {
				menu.value = false
			},
		},
	},
	{ type: 'divider' },
	...contentAlignValues.map((value) => ({
		title: t(`component.contentAlign.${value}`),
		value,
	})),
])

function change(values: ContentAlign[]) {
	const [value] = values
	if (!value) return
	contentAlign.value = value
	menu.value = false
}
</script>
